import { call } from 'redux-saga/effects';

import { getPublishedConnectionTableInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { PublishedConnectionTableCard } from '~src/app/spaces/CardView/PublishedConnectionTableCard';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionTables } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { PublishedConnectionTableContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const PublishedConnectionTableDefinition: MixedContentItemDefinition & SpaceDefinition<'publishedConnectionTable'>  = {
  contentType: 'publishedConnectionTable',
  itemType: 'publishedConnectionTable',
  pluralName: Messages.publishedConnectionTables,
  singularName: Messages.publishedConnectionTable,
  emptyStateMessage: Messages.publishedConnectionTablesEmpty,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnectionTables,
  contentFilterKeys: PublishedConnectionTableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PublishedConnectionTableCard,
  listViewIconUrl: imgPath('table_connection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['publishedConnectionTable']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.publishedConnectionTableUrl(contentId),
  getBasicQuery: () => {
    return PublishedConnectionTables.all().withExtraParams(PublishedConnectionTableContentType.extraQueryParams);
  },
  fieldValueResourceType: 'publishedConnectionTable',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionTableInfos, contentList),
  supportedDisplayModes: ['list'],
  headerIconPath: (contentInfo) => getPublishedConnectionTableIconPath(contentInfo),
};

export const getPublishedConnectionTableIconPath = (contentInfo: ISpaceItemDetailInfo<'publishedConnectionTable'>, headerIcon: boolean = true): string => {
  const properties = [];
  if (contentInfo.hasExtracts) {
    properties.push('extract');
  }
  if (properties.length > 0) {
    properties.push('');
  }

  if (headerIcon) {
    return imgPath(`table_connection_${properties.join('_')}60px_card.svg`);
  } else {
    return imgPath(`table_connection_${properties.join('_')}16px_medium.svg`);
  }
};

